import { useGlobalErrorDialog } from './state';
import type { GlobalErrorDialogProps } from './types';

/**
 * グローバルエラーダイアログを表示する
 */
export function openGlobalErrorDialog(props: GlobalErrorDialogProps) {
  useGlobalErrorDialog.getState().open(props);
}

/**
 * グローバルエラーダイアログを閉じる
 */
export function closeGlobalErrorDialog() {
  useGlobalErrorDialog.getState().close();
}